import { Col, Offcanvas, Row } from "react-bootstrap";
import IInspeccionObservacion, { IAspectoEvaluar, ICerrarAspecto } from "../../../entities/IInspeccionObservacion";
import LIOService from "../../../services/LIOService";
import { useRef, useState } from "react";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import ICurrentUser from "../../../entities/helper/ICurrentUser";
import { shortDate } from "../../../helpers/dateHelper";
import { AdminListaPagination, IPagination } from "../../../controls/AdminListaPagination";
import { ROW_COUNT } from "../../../helpers/variableHelper";
import { getFileName } from "../../../helpers/pathHelper";
import IDocumentoLIO, { IDocumentoLIOAspectoEvaluar } from "../../../entities/IDocumentoLIO";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { ITipo_Campo } from "../../../helpers/IFormHelper";
import { ModalCausaObservaciones, ModalCausaRechazo } from "../../deviation/components/Modal/ModalCausaObservaciones";
import { EnumTipoDocumentoAuditoria } from "../../../entities/helper/EnumTipoDocumentoAuditoria";
import DesviacionService from "../../../services/DesviacionService";
import { E_EstadoLIOAspectoEvaluar } from "../../../enums/E_EstadoLIO";
import RenderTitle from "../../../controls/RenderTitle";
import RenderValue from "../../../controls/RenderValue";

interface IAspectoEvaluarProps {
  token: string;
  idLIO: number;
  onClose: () => void;
  aspecto: IAspectoEvaluar | null;
  selectedLIO: IInspeccionObservacion | null;
  currentUser: ICurrentUser | null;
  items?: IDocumentoLIOAspectoEvaluar[];
}
export default function CerrarAspecto({ token, idLIO, onClose, aspecto, selectedLIO, currentUser, items }: IAspectoEvaluarProps) {
  const isZonalManager = (managers?: string | null, currUser?: ICurrentUser | null) => {
    if (managers !== undefined && managers !== null) {
      let arrayManagers = managers.split("; ");
      const isZonalManager = arrayManagers.some((manager) => manager.trim() === currUser?.email);
      return isZonalManager;
    }
    return false;
  };
  const [readonly] = useState(
    !(
      aspecto?.ID_ESTADO === E_EstadoLIOAspectoEvaluar.AccionRealizada &&
      (selectedLIO?.AUTOR === currentUser?.email || isZonalManager(selectedLIO?.USUARIO_ENCARGADO_ZO, currentUser))
    )
  );
  const totalPageListDocumentos = useRef<number>(0);
  const [documentosLIOAspecto, setDocumentosLIOAspecto] = useState<IDocumentoLIOAspectoEvaluar[]>(items || []);
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const componentVer = (info: any) => {
    return (
      <div>
        <i
          className="bi bi-search iconSearch"
          title="Ver Documento"
          data-testid="buttontest"
          onClick={() => {
            DesviacionService.getContenidoArchivo(token, info.row.original.URL);
          }}></i>
      </div>
    );
  };
  usePromiseEffect(async () => {
    if (idLIO) {
      await refreshDocuments();
    }
  }, []);

  const refreshDocuments = async (pagination?: IPagination | null) => {
    const defaultPagination: IPagination = pagination || {
      ORDENADOPOR: "ID",
      ORIENTACION: "ASC",
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
    };
    if (aspecto?.ID) {
      let result = await LIOService.getDocumentosLIOAspectoEvaluar(token, {
        ...defaultPagination,
        ID_TIPO_DOCUMENTO: EnumTipoDocumentoAuditoria.AspectoAsignado,
        ID_LIO_INSPECCION_OBSERVACION: idLIO,
        ID_LIO_ASPECTO_EVALUAR: aspecto?.ID,
      });
      totalPageListDocumentos.current = result.pages;
      setDocumentosLIOAspecto(result.data);
    }
  };

  const handleCerrarCausa = async (estado: number, observacion: boolean, Observación: string) => {
    if (aspecto) {
      let value: ICerrarAspecto = {
        ID: aspecto.ID != undefined ? aspecto.ID : null,
        ID_ESTADO: estado,
        OBSERVACION: observacion,
        EDITOR: currentUser?.email as string,
        EDITOR_DISPLAY: currentUser?.fullname as string,
        FECHA_MODIFICACION: new Date(),
        MOTIVO_RECHAZO: Observación,
      };
      let id = await LIOService.cerrarAspectoEvaluado(token, value);
      onClose();
      return id;
    }
  };

  const columnHelperLIODocumentos = createColumnHelper<IDocumentoLIO>();
  let columnsDefLIODocumentos = [
    columnHelperLIODocumentos.accessor((row) => row.URL, {
      id: "URL",
      cell: (info: CellContext<IDocumentoLIO, string>) => componentValue(getFileName(info.getValue())),
      header: () => component("Nombre Documento"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperLIODocumentos.accessor((row) => row.DESCRIPCION, {
      id: "DESCRIPCION",
      cell: (info: CellContext<IDocumentoLIO, string>) => componentValue(info.getValue()),
      header: () => component("Descripción"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperLIODocumentos.accessor((row) => row.ID, {
      id: "ACCIONES",
      cell: (info: CellContext<IDocumentoLIO, string>) => componentVer(info),
      header: () => component("Ver"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
  ] as any;

  return (
    <Offcanvas show={true} onHide={onClose} placement={"end"} className="w-50 modalAgregarCausa">
      <Offcanvas.Header closeButton className="border-bottom">
        <Offcanvas.Title className="m-3 mb-1 colorTit">{selectedLIO?.NUEVO_FORMATO_FAENA ? "Cerrar Acción" : "Cerrar Aspecto"}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="m-3">
        <div className="container-fluid mb-4">
          <button
            hidden={true}
            data-testid="testisZonalManager "
            onClick={() => {
              isZonalManager("", {} as ICurrentUser);
              handleCerrarCausa(1, true, "test");
            }}></button>
          <div className="card bg-light border p-3 pt-2 mt-2">
            <div className="col-sm-12 col-md-12 col-lg-12 mb-2">
              <h5 className="titPaneles">{selectedLIO?.NUEVO_FORMATO_FAENA ? "Acción" : "Aspecto"}</h5>
            </div>
            <div className="row mb-2 ajusteInput">
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <label>{selectedLIO?.NUEVO_FORMATO_FAENA ? "Nombre Acción:" : "Nombre Aspecto:"}</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  <p>{aspecto?.NOMBRE_ELEMENTO}</p>
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <label>{selectedLIO?.NUEVO_FORMATO_FAENA ? "N° Acción:" : "N° Aspecto:"}</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  <p>{aspecto?.TITULO}</p>
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <label>Fecha asignación:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  <p>{shortDate(aspecto?.FECHA_ASIGNACION)}</p>
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <label>Responsable acción:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  <p>{aspecto?.RESPONSABLE_DISPLAY}</p>
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <label>Fecha hasta:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  <p>{shortDate(aspecto?.FECHA_HASTA)}</p>
                </Col>
              </div>
              {!selectedLIO?.NUEVO_FORMATO_FAENA && (
                <div className="row mb-2 ajusteInput">
                  <Col xs="12" md="6" lg="4">
                    <label>Acción a realizar:</label>
                  </Col>
                  <Col xs="12" md="6" lg="8">
                    <p>{aspecto?.OBSERVACION}</p>
                  </Col>
                </div>
              )}
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <label>Acción realizada:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  <p>{aspecto?.ACCION_REALIZADA}</p>
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <label>Fecha accion realizada:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  <p>{shortDate(aspecto?.FECHA_ACCIONAR)}</p>
                </Col>
              </div>
              {aspecto?.ID_ESTADO == E_EstadoLIOAspectoEvaluar.Rechazado && (
                <div className="row mb-2 ajusteInput">
                  <Col xs="12" md="6" lg="4">
                    <label>Motivo de Rechazo:</label>
                  </Col>
                  <Col xs="12" md="6" lg="8">
                    <p>{aspecto?.MOTIVO_RECHAZO}</p>
                  </Col>
                </div>
              )}
              {aspecto?.ID_ESTADO == E_EstadoLIOAspectoEvaluar.CerradoConObservacion && (
                <div className="row mb-2 ajusteInput">
                  <Col xs="12" md="6" lg="4">
                    <label>Observación:</label>
                  </Col>
                  <Col xs="12" md="6" lg="8">
                    <p>{aspecto?.MOTIVO_RECHAZO}</p>
                  </Col>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="container-fluid mb-4">
          <div className="card bg-light border p-3 pt-2 mt-2">
            <div className="col-sm-12 col-md-12 col-lg-12 mb-2">
              <h5 className="titPaneles">Evidencia</h5>
            </div>

            <AdminListaPagination
              defaultSortBy="ID"
              sortDirection="DESC"
              totalPages={totalPageListDocumentos}
              resultPerPage={ROW_COUNT}
              callback={(pagination) => {
                refreshDocuments(pagination);
              }}
              data={documentosLIOAspecto}
              reload={() => {
                refreshDocuments();
              }}
              columnsDef={columnsDefLIODocumentos}
              hideAdd={true}
              hideExport={true}
            />
          </div>
        </div>

        <Row className="mb-2 ajusteInput mt-4">
          <Col xs="4" md="4" lg={"4"}></Col>
          <Col xs="4" md="4" lg={"8"} className="text-center">
            {!readonly ? (
              <span>
                <button
                  className="btn btn-sm btn-primary me-2"
                  onClick={() => {
                    handleCerrarCausa(E_EstadoLIOAspectoEvaluar.Cerrado, false, "");
                  }}>
                  Cerrar
                </button>
                <button
                  className="btn btn-sm btn-primary me-2"
                  onClick={() => {
                    ModalCausaObservaciones(async (observacion: string) => {
                      handleCerrarCausa(E_EstadoLIOAspectoEvaluar.CerradoConObservacion, true, observacion);
                    });
                  }}
                  // disabled={isSendingData}
                >
                  Cerrar con Observaciones
                </button>
                {aspecto?.MOTIVO_RECHAZO == null && (
                  <button
                    className="btn btn-sm btn-primary me-2"
                    onClick={() => {
                      ModalCausaRechazo(async (observacion: string) => {
                        handleCerrarCausa(E_EstadoLIOAspectoEvaluar.Rechazado, true, observacion);
                      });
                    }}
                    // disabled={isSendingData}
                  >
                    Rechazar
                  </button>
                )}
              </span>
            ) : (
              ""
            )}
            <button
              className="btn btn-sm btn-primary me-2"
              onClick={() => {
                onClose();
              }}
              // disabled={isSendingData}
            >
              Volver
            </button>
          </Col>
          <Col xs="4" md="4" lg={"2"}></Col>
        </Row>
      </Offcanvas.Body>
    </Offcanvas>
  );
}
